import { FlexRow } from '@/components/common/Flex';
import { useTrackModalShown } from '@/services/analytics/useTracking';
import { Box, Center, Image, Spinner } from '@chakra-ui/react';
import { FlexCol } from '../common/Flex';
import { PlentyLogo } from '../common/icons';
import Modal from '../common/modals/Modal';
import { Header } from '../common/Typography';
import ModalManager, { useModal } from '../ModalManager';
import { ACCOUNT_LINKING_MODAL_CONTENT_HEIGHT } from './helpers';

export interface AccountLinkingInProgressModalProps {
    institutionName?: string;
    institutionId?: string;
    logoUrl?: string | null;
}

export const showAccountLinkingInProgressModal = (
    props: AccountLinkingInProgressModalProps
) => ModalManager.show(AccountLinkingInProgressModal, props);

export const hideAccountLinkingInProgressModal = () =>
    ModalManager.hide(AccountLinkingInProgressModal);

const AccountLinkingInProgressModal =
    ModalManager.create<AccountLinkingInProgressModalProps>(
        ({ institutionName, logoUrl }) => {
            useTrackModalShown('Account Linking In Progress');

            const modal = useModal();

            return (
                <Modal
                    size="md"
                    isCentered
                    isOpen={modal.visible}
                    onClose={() => {
                        modal.hide();
                    }}
                    closeOnOverlayClick={false}
                    renderContent={() => (
                        <FlexCol h={ACCOUNT_LINKING_MODAL_CONTENT_HEIGHT}>
                            <Header textAlign="center">
                                {institutionName
                                    ? 'Importing your accounts from'
                                    : 'Importing your accounts'}
                            </Header>
                            <Center w="full" h="full">
                                <FlexCol textAlign="center" gap={6}>
                                    <BankLogoSpinner logo={logoUrl} />
                                    <Header>{institutionName}</Header>
                                </FlexCol>
                            </Center>
                        </FlexCol>
                    )}
                />
            );
        }
    );

const BankLogoSpinner = ({ logo }: { logo?: string | null }) => (
    <FlexRow justify="center" align="center">
        <Box h={12} w={12}>
            {logo ? (
                <Image src={logo} alt="logo" rounded="full" />
            ) : (
                <Center bg="gray.700" w="full" h="full" rounded="full">
                    <PlentyLogo size="lg" color="white" />
                </Center>
            )}
        </Box>
        <Spinner
            w={16}
            h={16}
            position="absolute"
            color="blackAlpha.200"
            speed="1s"
        />
    </FlexRow>
);

export default AccountLinkingInProgressModal;
